/**
 * Shared font family definitions for Tamagui.
 * Web and native each wrap these with their platform-specific font creators.
 *
 * Web uses Geist (sans) + Geist Mono (numeric/tabular cells, timestamps, codes).
 * Native stays on Inter (Geist is not bundled for React Native).
 */

export const webFontFamily =
    '"Geist", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'

export const webFontFamilyMono =
    '"Geist Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'

export const nativeFontFamily = 'Inter'
